module.exports = __webpack_public_path__ + "img/manseki.895fd3f1.jpg";